import { render, staticRenderFns } from "./DependencyPreview.vue?vue&type=template&id=5e48e24c&scoped=true&"
import script from "./DependencyPreview.vue?vue&type=script&lang=js&"
export * from "./DependencyPreview.vue?vue&type=script&lang=js&"
import style0 from "./DependencyPreview.vue?vue&type=style&index=0&id=5e48e24c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48e24c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e48e24c')) {
      api.createRecord('5e48e24c', component.options)
    } else {
      api.reload('5e48e24c', component.options)
    }
    module.hot.accept("./DependencyPreview.vue?vue&type=template&id=5e48e24c&scoped=true&", function () {
      api.rerender('5e48e24c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/taskSettings/sections/dependencies/includes/DependencyPreview.vue"
export default component.exports